export default class BPLieferungTerminWaehlenRequest {
  id: string
  type: string
  zeitpunkt: string
}
